import React, { useState , useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import EditIcon from '@mui/icons-material/Edit';
import ReceiptIcon from '@mui/icons-material/Receipt';
import {read} from "../../../pages/Kontrak/API/Step1/api.js";
import {readEmpty} from "../../../pages/Kontrak/API/Step1/apiEmpty.js";
import Dialog from '@mui/material/Dialog';
import NewKlienPopUp from '../../../pages/Kontrak/createKontrak/NewKlienPopUp';
import ConfirmCompany from '../../../components/ConfirmCompany';


const KlienChange = ({changeKlienPopUpOpen, changeKlienPopUpClose, setContractData, contractData}) => {
  const [query, setQuery] = useState('');
  const [skip, setSkip] = useState(0)
  const [posts, setPosts] = useState([])
  const [isEnd,setIsEnd] = useState("loading..")
  const [open, setOpen] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [thisCompany,setThisCompany] = useState();

  useEffect(() => {
    fetchPosts();
}, [skip,query]);

  const history = useNavigate();

  const handleScroll = (e) => {
    const { offsetHeight, scrollTop, scrollHeight } = e.target;

    // start fetching more content when the user is within 50px of the bottom
    const threshold = 50;

    if (scrollHeight - (offsetHeight + scrollTop) <= threshold) {
        setSkip(posts?.length);
    }
};




  const handleSearch = (event) =>{
    setQuery(event.target.value)
    setSkip(0)
    newFetchPosts(event)
}

const newKlien = () => {
    setOpen(true)
}
  
  
const fetchPosts = async () => {
    console.log("feeeetchiiing")
  if(query.trim()){
          try{
              const { data, error } = await read(skip,query);
              if(error){
                  console.log(error.message);
                  return;
              }
  
              if(data?.length === 0){
                  setIsEnd("Selesai...");
                  return;
              }
              
              //success
              setPosts([...posts, ...data])
          }catch(error){
              console.log(error.message);
          }
      
  }else{

  try{
      const { data, error } = await readEmpty(skip,query);
      if(error){
          console.log(error.message);
          return;
      }

      if(data?.length === 0){
          setIsEnd("Selesai...");
          return;
      }
      
      //success
      setPosts([...posts, ...data])
  }catch(error){
      console.log(error.message);
  } 
  }
}  

const handleClose = () => {
  setOpen(false);
};

const handleCloseConfirm = () => {
    setOpenConfirm(false);
  };
const newFetchPosts = async (event) => {

  setPosts([])
  setIsEnd("Loading...");
  if(event.target.value.trim()){
  try{
      const { data, error } = await read(skip,event.target.value);
      if(error){
          console.log(error.message);
          return;
      }

      if(data?.length === 0){
          setIsEnd("Selesai...");
          return;
      }
      
      //success
      setPosts([...data])
  }catch(error){
      console.log(error.message);
  }
  }else{
      console.log("empty")
      try{
          const { data, error } = await readEmpty(skip,event.target.value);
          if(error){
              console.log(error.message);
              return;
          }

          if(data?.length === 0){
              setIsEnd("Selesai...");
              return;
          }
          
          //success
          setPosts([...posts, ...data])
      }catch(error){
          console.log(error.message);
      } 
  }
}
function handleClick(post) {
    setContractData({...contractData, KlienID: post._id, KlienNama: post.Nama });
    // props.setklienID(post._id)
    console.log(post._id)
    changeKlienPopUpClose();
    // props.setcompanyID(post.Companies[0].CompanyID)
    // props.nextButton(post);
    // console.log("this is the post" + post._id)
    // props.setklienID(post._id)
}

  return (
    <Grid container>
      <Grid>
        <Button onClick={newKlien}>New +</Button>
        <TextField
          value={query}
          onChange={handleSearch}
          placeholder="Search..."
        />
      </Grid>
      <Dialog open={open} onClose={handleClose}>
    <NewKlienPopUp stuff="new" handleClose={handleClose} changeKlienPopUpClose={changeKlienPopUpClose} setContractData={setContractData} contractData={contractData} />
</Dialog>
<Dialog open={openConfirm} onClose={handleCloseConfirm}>
    <ConfirmCompany stuff="new" thisCompany={thisCompany} handleCloseConfirm={handleCloseConfirm}/>
</Dialog>

      <Grid container align = "center" justify = "center" alignItems = "center">
                            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                                <TableContainer sx={{ maxHeight: 400, minHeight: 350 }} className="min-h-screen h-screen overflow-scroll" onScroll={handleScroll}>
                                    <Table stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>
                                                    Direktur/PIC
                                                </TableCell>
                                                <TableCell>
                                                    Company
                                                </TableCell>
                                                <TableCell>
                                                    Nomor Telepon
                                                </TableCell>
                                                
                                            </TableRow>
                                        </TableHead>
                                        {posts?.map((post) => (
                                            post.Companies.map((company, index) => (
                                            <TableBody>
                                                <TableRow
                                                    key={`${post.id}-${index}`}
                                                    hover
                                                    onClick={() => handleClick(post)}
                                                >
                                                    <TableCell style={{cursor:'pointer'}}>
                                                        <p>{post.Nama}</p>
                                                    </TableCell>
                                                    <TableCell style={{cursor:'pointer'}}>
                                                        <p>{post.Companies[0].NamaPT}</p>
                                                    </TableCell>
                                                    <TableCell style={{cursor:'pointer'}}>
                                                        <p>{post.Phone}</p>
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        ))))}
                                        {isEnd}
                                    </Table>
                                </TableContainer>
                            </Paper>
                                
                            </Grid>
    </Grid>
  );
};

export default KlienChange;